export default __webpack_public_path__ + "static/media/36I-114287_-20987_0.82a29121.jpg";